import socketIOClient from "socket.io-client";
const socket = socketIOClient("https://paaske2019.kode24.no");
function submitCommand(command) {
  //socket.on("timer", timestamp => cb(null, timestamp));
  socket.emit("typed mystery password", command);
}

export { submitCommand };
